<template>
  <div class="page-data">
    <el-form ref="form" :model="value">
      <el-form-item label="用户名：">
        <el-input v-model="value.user_name" disabled style="width:250px" :maxlength="8"></el-input>
      </el-form-item>
      <el-form-item label="头像：">
        <div class="portrait-Img">
          <img :src="imgUrl == '' ? deafult : imgUrl" alt />
          <div class="file-box">
            <input class="file-updata" @change="uploadPicture" type="file" />
          </div>
        </div>
      </el-form-item> 
    </el-form>
  </div>
</template>

<script>
import { setadminpic } from "@/api/api";
export default {
  data() {
    return {
      value: {
        user_name: ""
      },
      user:{},
      imgUrl: "",
      deafult:
        "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1562929485581&di=d8f57f0c310c8eb6099e3c52a8a33986&imgtype=0&src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201704%2F27%2F20170427155254_Kctx8.thumb.700_0.jpeg"
    };
  },
  created() {},
  methods: {
    uploadPicture(e) {
      let fileName = e.target.files[0].name;
      console.log(fileName);
      let regex = /(.jpg|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        let formData = new FormData();
        let parms = e.target.files[0];
        console.log(parms);
        formData.append("uploadFile", parms);
        setadminpic(formData).then(res => {
          if (res.errno == 0) {
            this.imgUrl = res.data.fileUrl;
            var url = this.imgUrl.lastIndexOf("/");
            var relUrl = this.imgUrl.substring(url+1)
            let user = {
              admin_role_id:this.user.admin_role_id,
              avatar:relUrl,
              id:this.user.id,
              username:this.user.username
            }
             sessionStorage.setItem('user', JSON.stringify(user))
            this.$message({
              message:'头像上传成功',
              type:"success"
            })
            setTimeout(()=>{
              window.location.reload()
            },1000)
          }
        });
      } else {
        this.$message.error("请注意图片格式和上传图片数量");
        return;
      }
    },
    submitForm() {}
  },
  mounted() {
    var user = sessionStorage.getItem("user");
    user = JSON.parse(user);
    this.user = user
    console.log(user);
    this.value.user_name = user.username;
  }
};
</script>

<style lang="scss" scoped>
.page-data {
  .portrait-Img {
    margin-left: 110px;
    width: 70px;
    height: 70px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .file-box {
      position: absolute;
      right: -10px;
      bottom: 0px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: url("../../../assets/img/touxiangshangchuan.png");
      background-size: cover;
      .file-updata {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        opacity: 0;
      }
    }
  }
  .btn-box {
    margin: 30px 0 0 68px;
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?bc4cad40